import type { Placement } from '@popperjs/core/lib/enums'
import cx from 'classnames'
import isFunction from 'lodash/isFunction'
import type React from 'react'
import type { ReactNode } from 'react'

import { DropdownContainer } from '../DropdownContainer'
import { NewTooltip } from '../NewTooltip'
import css from './EllipsisMenu.module.scss'

type Props = {
  customClassName?: string
  dropdownContainerClassName?: string
  withTooltip?: boolean
  position?: Placement
  onClick?: () => void
  onOutsideClick?: () => void
  children: ReactNode | ((close: () => void) => ReactNode)
}

export const EllipsisMenu: React.FC<Props> = ({
  customClassName,
  dropdownContainerClassName,
  withTooltip,
  position = 'bottom-start',
  onClick,
  onOutsideClick,
  children,
}) => {
  return (
    <DropdownContainer
      position={position}
      offset={{ y: 8 }}
      customClassName={dropdownContainerClassName}
      onOutsideClick={onOutsideClick}
      renderButton={(onSetDropdownRef, onDropdownClick, isOpen) =>
        withTooltip ? (
          <NewTooltip
            content="Options"
            offset={{ y: 4 }}
            renderEl={(onSetRef, onMouseEnter, onMouseLeave) => (
              <button
                ref={(element) => {
                  onSetDropdownRef(element)
                  onSetRef(element)
                }}
                className={cx(css.ellipsisBtn, customClassName, {
                  [css.active]: isOpen,
                })}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                onClick={() => {
                  onDropdownClick()
                  onClick?.()
                }}
              >
                <i className="fa fa-ellipsis-v" />
              </button>
            )}
          />
        ) : (
          <button
            ref={onSetDropdownRef}
            className={cx(css.ellipsisBtn, customClassName, {
              [css.active]: isOpen,
            })}
            onClick={(e) => {
              e.stopPropagation()
              onDropdownClick()
              onClick?.()
            }}
          >
            <i className="fa fa-ellipsis-v" />
          </button>
        )
      }
    >
      {(closeDropdown) =>
        isFunction(children) ? children(closeDropdown) : children
      }
    </DropdownContainer>
  )
}
